import { APP_IS_LOADING } from 'vx/mutations'
import store from 'vx/store'

window.paceOptions = {
  startOnPageLoad: false,
  restartOnPushState: false,
  restartOnRequestAfter: false,
  ajax: {
    trackWebSockets: false
  }
}

const pace = require('pace/pace')

pace.on('start', () => {
  store.commit(`app/${APP_IS_LOADING}`, true)
})

pace.on('hide', () => {
  setTimeout(() => {
    store.commit(`app/${APP_IS_LOADING}`, false)
  }, 100)
})

export default pace

export const routeWantsPace = (matched, to, from) => {
  if (to.name === 'login' || from.name === 'login') {
    return false
  }
  if (typeof matched.meta.pace === 'function') {
    return matched.meta.pace(to, from)
  }

  return matched.meta.pace
}
